<template>
  <MrSushi v-if="showMrSushiLanding" />
  <Menu v-else :tid="tid" :ts="ts" />
</template>

<script>
import Menu from "./menu.vue";
import MrSushi from "../mr-sushi";

const MR_SUSHI_CODES = [
  "173ab3f4-a29c-4a71-85e3-391aca992ca1",
  "b1ff0a0b-277c-4e86-8844-daff567d1815"
];

export default {
  name: "QrMenuEntry",
  components: { Menu, MrSushi },
  props: {
    tid: { type: Number, default: null },
    ts: { type: String, default: "" }
  },
  computed: {
    showMrSushiLanding() {
      return (
        MR_SUSHI_CODES.includes(this.$route.params.code) &&
        this.$route.query.menu !== "1"
      );
    }
  }
};
</script>